// extracted by mini-css-extract-plugin
export var body = "Faq-module--body--a0aaa";
export var wrapper = "Faq-module--wrapper--04937";